/**
 * Created by Andrey Popov on 10.11.2021
 */

const ImageSpy = function (atlasAnalyzer) {
    this.atlasAnalyzer = atlasAnalyzer;

    cleverapps.EventEmitter.call(this);

    this.atlasAnalyzer.textureImage.on("selectTextureFrame", this.showAssetInfo.bind(this));
    this.atlasAnalyzer.textureImage.on("showIllustration", this.showAssetInfo.bind(this));
    this.atlasAnalyzer.textureImage.on("removeData", () => this.trigger("removeData"));
};

ImageSpy.prototype = Object.create(cleverapps.EventEmitter.prototype);
ImageSpy.prototype.constructor = ImageSpy;

ImageSpy.prototype.showAssetInfo = function (asset) {
    this.trigger("updateAssetData", this.getData(asset));
};

ImageSpy.prototype.getData = function (asset) {
    const textureMap = this.atlasAnalyzer.textureImage.textureMap;
    let href = "";
    if (cleverapps.isLocalhost()) {
        const url = new URL(location.href);
        url.hash = "";
        href = url.href;
    }

    let framesWithoutLink, unusedFrames;
    if (textureMap) {
        framesWithoutLink = textureMap.frames.filter((frame) => !frame.link);
        unusedFrames = textureMap.frames.filter((frame) => frame.unused);
    }

    const bundlesThatAddImages = Object.keys(bundles)
        .filter((bundleName) => {
            const bundle = bundles[bundleName];

            if (textureMap) {
                return bundle.injectTo && bundle.injectTo.includes(textureMap.texture.name);
            }

            return bundle.meta.originalPaths && bundle.meta.originalPaths.illustration && bundle.meta.originalPaths.illustration === asset.link;
        })
        .map((bundleName) => ({ name: bundleName }));

    const virtualBundleOwners = textureMap && bundles[textureMap.texture.name].meta.virtualBundleOwners;
    const ownerBundle = virtualBundleOwners
        && (asset.name && virtualBundleOwners[asset.name] || asset.key && virtualBundleOwners[asset.key]);

    return {
        "Bundle": textureMap && {
            value: `${textureMap.texture.name} ${textureMap.texture.size.width}x${textureMap.texture.size.height} ${textureMap.texture.byteSize}`,
            link: href + bundles[textureMap.texture.name].urls.png.url
        },
        "Virtual bundle": ownerBundle && {
            value: ownerBundle,
            linkStyle: true,
            onClick: function () {
                const baseUrl = cleverapps.isLocalhost() ? window.location.href.split("#")[0] : window.location.origin;
                const urlHash = cleverapps.toUrlHash({
                    atlasAnalyzer: true,
                    bundleName: `${ownerBundle}-${textureMap.texture.name}-debug`,
                    tab: "Debug"
                });
                connector.platform.openUrl(`${baseUrl}#${urlHash}`);
            }
        },
        "Image name": {
            value: asset.unpackedName || asset.name,
            onClick: function (item) {
                cleverapps.copyToClipboard(item);
            }
        },
        "Image size": {
            value: `${asset.size.width}x${asset.size.height}`
        },
        "Image path": {
            value: asset.link,
            link: asset.gitLink,
            errorMessage: asset.link ? undefined : "Unknown image path! Check image usage!"
        },
        "Questionable images": framesWithoutLink && {
            hideIfTrue: framesWithoutLink.length === 0,
            values: framesWithoutLink,
            onClick: function (item) {
                cleverapps.atlasAnalyzer.textureImage.selectFrame(item, true);
            },
            error: true
        },
        "Unused decorators": unusedFrames && cleverapps.config.type === "merge" && {
            hideIfTrue: unusedFrames.length === 0,
            values: unusedFrames,
            onClick: function (item) {
                cleverapps.atlasAnalyzer.textureImage.selectFrame(item, true);
            },
            error: true
        },
        "Bundles that add images": {
            hideIfTrue: bundlesThatAddImages.length === 0,
            values: bundlesThatAddImages,
            onClick: function (item) {
                cleverapps.copyToClipboard(item.name);
            }
        }
    };
};
